import { render, staticRenderFns } from "./viewAktiven.vue?vue&type=template&id=545c473a&scoped=true&"
import script from "./viewAktiven.vue?vue&type=script&lang=js&"
export * from "./viewAktiven.vue?vue&type=script&lang=js&"
import style0 from "./viewAktiven.vue?vue&type=style&index=0&id=545c473a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545c473a",
  null
  
)

export default component.exports